import { columns } from "../../../../dtos/columns";
import { format } from "rut.js";
import { AdministrarPatEdit, PatDTO } from "../models/administrarPat";
import AccionesPat from "../components/accionesPat";



interface IProps {
    controlTabla: any;
    setPatEditar: React.Dispatch<React.SetStateAction<AdministrarPatEdit | undefined>>;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
    isEdit: (value: boolean) => void;
}

export function useColumns({ controlTabla, setPatEditar, setModalDetalle, isEdit }: IProps) {

    const COLUMNS: columns<PatDTO>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesPat
                  pat={row}
                    control={controlTabla}
                    setPatEditar={setPatEditar}
                    setModalDetalle={setModalDetalle}
                    isEdit={isEdit}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'N° operación',
            selector: (row) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'RUT deudor',
            selector: (row) =>
                format(row.rutDeudor ?? ''),
            sortable: true,
            sortField: 'rutDeudor',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre deudor',
            selector: (row) => row.nombreCompleto,
            sortable: true,
            sortField: 'nombreCompleto',
            wrap: true,
            export: true
        },
        {
            name: 'Llave PAT',
            selector: (row) => row.llavePat,
            sortable: true,
            sortField: 'llavePat',
            wrap: true,
            export: true
        },
        {
            name: 'Estado PAT',
            selector: (row) => row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true
        },
    ];

    return { COLUMNS };
}